namespace SP.Data {
    export class Shipment {


        static async getShipmentInfo(shipmentId: string) {
            var response = await SP.get<any>("/api/v1/info/shipmentInfo/" + shipmentId);
            if (response.status == 200) return response.data as SP.ShipmentInfo;
            else await SP.alertX(response.status + ": " + response.msg);
            return null;
        }

        static async getHistoryShipmentInfo(barcode: string = "", keyword: string = "") {
            var bc = encodeURIComponent(barcode);
            var kw = encodeURIComponent(keyword);
            var response = await SP.get<any>("/api/v1/shipment/history?barcode=" + bc + "&keyword=" + kw);
            if (response.status == 200) return response.data as SP.HistoryShipmentInfo[];
            else await SP.alertX(response.status + ": " + response.msg);
            return null;
        }

    }
}